<template>
  <div class="inprogress-column p-3 mb-3">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <h3 class="column-title m-0">
        <i class="fas fa-spinner fa-spin text-primary me-2"></i>In Progress
      </h3>
      <span class="badge bg-primary rounded-pill shadow-sm px-3">{{ InProgressTasks.length }}</span>
    </div>

    <div class="task-card mb-3 p-3 shadow-sm" v-for="(inprogressTask, index) in InProgressTasks" :key="index">
      
      <div class="user-assignment d-flex align-items-center mb-3 pb-2 border-bottom border-light">
        <div class="avatar-wrapper">
          <div class="avatar-main shadow-sm bg-light">
            <img v-if="inprogressTask.assigned_profile || inprogressTask.creator_profile" 
                 :src="inprogressTask.assigned_profile || inprogressTask.creator_profile" 
                 class="avatar-img shadow-sm" 
                 alt="Worker">
            <span v-else class="avatar-placeholder">
              {{ (inprogressTask.assigned_name || inprogressTask.username || 'U').charAt(0).toUpperCase() }}
            </span>
          </div>
          <div class="status-pulse"></div>
        </div>
        
        <div class="ms-3">
          <p class="user-name m-0">{{ inprogressTask.assigned_name || inprogressTask.username || 'In Action' }}</p>
          <small class="user-role text-primary fw-bold">Currently Working</small>
        </div>
      </div>

      <div class="task-body">
        <h5 class="task-title text-dark">{{ inprogressTask.title }}</h5>
        
        <div class="task-meta mt-2 d-inline-flex align-items-center">
          <i class="far fa-clock me-2 text-primary"></i>
          <span class="small fw-bold">Started: {{ inprogressTask.start_date ? formatDate(inprogressTask.start_date) : formatDate(inprogressTask.created_at) }}</span>
        </div>
      </div>

      <div class="task-actions d-flex justify-content-end mt-3 pt-2 border-top">
        <button class="btn-action detail-btn" @click="$emit('show-detail', inprogressTask)" title="View Details">
           <i class="fas fa-comment"></i>
        </button>
        <button class="btn-action delete-btn" @click="$emit('delete-task', inprogressTask.id, inprogressTask.status)" title="Delete Task">
          <i class="fas fa-trash-alt"></i>
        </button>
      </div>
    </div>

    <div v-if="InProgressTasks.length === 0" class="empty-state text-center py-5">
      <i class="fas fa-tasks fa-3x mb-3 text-muted opacity-25"></i>
      <p class="text-muted small">No tasks currently in progress.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "InProgress",
  props: ["InProgressTasks"],
  methods: {
    formatDate(dateString) {
      if (!dateString) return "N/A";
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    }
  }
}
</script>

<style scoped lang="scss">
$primary-blue: #0984e3;
$card-bg: #ffffff;

.inprogress-column {
  background-color: rgba(232, 240, 254, 0.5); // Soft blue background
  border-radius: 20px;
  border: 1px solid rgba($primary-blue, 0.1);
  min-height: 250px;
}

.column-title {
  font-weight: 800;
  color: #2d3436;
  font-size: 1.2rem;
  letter-spacing: -0.5px;
}

.task-card {
  background: $card-bg;
  border-radius: 16px;
  border: 1px solid rgba(0,0,0,0.02);
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  // Left border accent
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 15%;
    bottom: 15%;
    width: 4px;
    background-color: $primary-blue;
    border-radius: 0 4px 4px 0;
  }

  &:hover {
    transform: translateY(-5px) scale(1.01);
    box-shadow: 0 12px 24px rgba($primary-blue, 0.12) !important;
    border-color: rgba($primary-blue, 0.3);
  }
}

.avatar-wrapper {
  position: relative;
  .avatar-main {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #fff;
  }
  .avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .avatar-placeholder {
    font-weight: 800;
    color: $primary-blue;
    font-size: 1rem;
  }

  // Pulse animation for status
  .status-pulse {
    position: absolute;
    bottom: -2px;
    right: -2px;
    width: 12px;
    height: 12px;
    background-color: $primary-blue;
    border: 2px solid #fff;
    border-radius: 50%;
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: $primary-blue;
      border-radius: 50%;
      animation: pulse 1.5s infinite;
      opacity: 0.6;
    }
  }
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 0.6; }
  100% { transform: scale(2.5); opacity: 0; }
}

.user-name {
  font-weight: 700;
  font-size: 0.9rem;
  color: #2d3436;
}

.user-role {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.task-title {
  font-weight: 700;
  font-size: 1.05rem;
  color: #1e272e;
  margin: 0;
}

.task-meta {
  background: rgba($primary-blue, 0.08);
  padding: 4px 12px;
  border-radius: 8px;
  color: $primary-blue;
}

.btn-action {
  background: transparent;
  border: none;
  padding: 8px 12px;
  margin-left: 6px;
  border-radius: 10px;
  color: #636e72;
  transition: all 0.2s;

  &:hover { background: #f1f2f6; color: $primary-blue; }
  &.delete-btn:hover { background: #fff5f5; color: #d63031; }
}

.empty-state {
  border: 2px dashed rgba($primary-blue, 0.2);
  border-radius: 20px;
}
</style>